<template>
    <section :class="sectionClass">
        <div :class="containerClass">
            <FeaturePageBadge
                v-if="badgeText !== null"
                :text="badgeText"
                variant="upcoming"
                uppercase
            />

            <h1
                class="text-4xl font-bold tracking-tight sm:text-5xl"
                :class="badgeText !== null ? 'mt-4' : ''"
            >
                {{ title }}
            </h1>
            <p
                class="mx-auto mt-5 text-lg text-slate-600"
                :class="subtitleMaxWidthClass"
            >
                {{ subtitle }}
            </p>

            <slot name="afterSubtitle" />

            <FeaturePagePrimaryButton
                v-if="buttonLabel !== null && buttonUrl !== null"
                :href="buttonUrl"
                :label="buttonLabel"
                class="mt-8"
            />
        </div>
    </section>
</template>

<script setup lang="ts">
    import FeaturePageBadge from '@/Marketing/LandingPage/Component/FeaturePage/Badge.vue'
    import FeaturePagePrimaryButton from '@/Marketing/LandingPage/Component/FeaturePage/PrimaryButton.vue'

    interface FeaturePageHeroSectionProps {
        title: string
        subtitle: string
        buttonLabel?: string | null
        buttonUrl?: string | null
        badgeText?: string | null
        subtitleMaxWidthClass?: string
        sectionClass?: string
        containerClass?: string
    }

    withDefaults(defineProps<FeaturePageHeroSectionProps>(), {
        buttonLabel: null,
        buttonUrl: null,
        badgeText: null,
        subtitleMaxWidthClass: 'max-w-3xl',
        sectionClass: 'border-b border-slate-200 bg-white',
        containerClass:
            'mx-auto max-w-7xl px-4 py-20 text-center sm:px-6 lg:px-8',
    })
</script>
